import { Box, Button, Chip, MuiIcons, Typography } from "@leap4/frontend";
import React from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { urlService } from "../../../routing/urlsService";
import Dashboard from "../index";

const { ChevronLeft, TravelExplore, FactCheck } = MuiIcons;

/** One publisher, shown through the Overall view with every panel scoped to it. */
const PublisherWorkspace = (): JSX.Element => {
    const history = useHistory();
    const location = useLocation();
    const campaign = new URLSearchParams(location.search).get("campaign");
    const { publisher: raw } = useParams<{ publisher: string }>();
    const publisher = decodeURIComponent(raw ?? "");

    const toExplorer = (view?: "verification"): void => {
        const p = new URLSearchParams({ analyzeBy: "app_bundle", minImpressions: "0" });
        p.append("publisher", publisher);
        if (view) p.set("view", view);
        if (campaign) p.set("campaign", campaign);
        history.push(`${urlService.dashboardExplorer()}?${p.toString()}`);
    };

    return (
        <Box>
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 1.5,
                    flexWrap: "wrap",
                    px: 2,
                    pt: 2,
                }}
            >
                <Button
                    size="small"
                    variant="outlined"
                    startIcon={<ChevronLeft />}
                    onClick={() =>
                        history.push(
                            campaign
                                ? `${urlService.dashboardPublishers()}?campaign=${encodeURIComponent(campaign)}`
                                : urlService.dashboardPublishers()
                        )
                    }
                >
                    Publishers
                </Button>
                <Typography variant="h6" sx={{ minWidth: 0 }}>
                    {publisher || "—"}
                </Typography>
                <Chip size="small" label="Scoped" color="primary" variant="outlined" />

                <Box sx={{ ml: "auto", display: "flex", gap: 1 }}>
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<TravelExplore sx={{ fontSize: 16 }} />}
                        onClick={() => toExplorer()}
                    >
                        Explore
                    </Button>
                    <Button
                        size="small"
                        variant="outlined"
                        startIcon={<FactCheck sx={{ fontSize: 16 }} />}
                        onClick={() => toExplorer("verification")}
                    >
                        Verification
                    </Button>
                </Box>
            </Box>

            <Dashboard publisher={publisher} embedded />
        </Box>
    );
};

export default PublisherWorkspace;
